module.exports = __webpack_public_path__ + "img/rank2.323ff894.svg";